import { useParams } from "react-router-dom";
import { EvidenceDetail } from "@/features/oversight/evidence";

export default function EvidenceDetailPage() {
  const { id } = useParams();
  return <EvidenceDetail id={id!} />;
}
